<template>
  <a-modal
    :visible="asyncVisible === 0 ? false : true"
    :title="asyncVisible === 1 ? '同步记录' : '同步Collection'"
    @ok="() => {}"
    @cancel="() => asyncVisibleChange(0)"
    :style="`width: ${asyncVisible === 1 ? 900 : 1200}px;`"
  >
    <div v-if="asyncVisible === 1">
      <a-table
        :dataSource="logList"
        :columns="logColumns"
        :pagination="false"
        :scroll="{ y: 300 }"
      >
        <template #status="{record}">
          <span>{{
            record.status - 0 === 0
              ? '同步中'
              : record.status - 0 === 1
              ? '同步成功'
              : `${record.successNum}条成功,${record.failNum}条失败`
          }}</span>
          <a-button
            type="link"
            v-if="record.status - 0 !== 0"
            @click="() => downloadFun({ id: record.id })"
            >下载同步数据</a-button
          >
        </template>
      </a-table>
      <div class="mt20 tar">
        <a-pagination
          v-model:current="logPagination.pageNum"
          :total="logPagination.total"
          @change="initLog"
        />
      </div>
    </div>
    <div v-if="asyncVisible === 2" style="overflow: hidden;">
      <div class="df">
        <div style="border-right: 1px solid #ddd;" class="pr20 mr20">
          <h3 class="mb20">未添加collection</h3>
          <div class="mb10">
            <a-input-group compact>
              <a-select
                v-model:value="unAddQuery.queryType"
                style="width: 144px;"
              >
                <a-select-option
                  :key="key"
                  :value="item.value"
                  v-for="(item, key) in queryTypeOptions"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
              <a-input
                v-model:value="unAddQuery.search"
                style="width: 410px;"
                placeholder="支持多个筛选，以英文逗号分割"
                @change="
                  e =>
                    searchInputLengthCut({
                      val: e.target.value,
                      key: 'unAddQuery'
                    })
                "
                @pressEnter="asyncSearch"
              >
                <template #prefix>
                  <SearchOutlined
                    class="cp"
                    style="color: #ccc;"
                    @click="asyncSearch"
                  />
                </template>
              </a-input>
            </a-input-group>
          </div>
          <div>
            <a-table
              :dataSource="asyncDataSource"
              :columns="asyncColumns"
              :pagination="false"
              :scroll="{ y: 300 }"
            >
              <template #titleSlot="{index, record}">
                <div class="df">
                  <a-checkbox
                    :checked="false"
                    class="mr10"
                    @change="() => addCol(index, record)"
                  ></a-checkbox>
                  <div style="width: 100px;">{{ record.title }}</div>
                </div>
              </template>
            </a-table>
          </div>
        </div>
        <div>
          <h3 class="mb20">已添加collection</h3>
          <div class="mb10">
            <a-input-group compact>
              <a-select
                v-model:value="unAddQuery.queryType"
                style="width: 144px;"
              >
                <a-select-option
                  :key="key"
                  :value="item.value"
                  v-for="(item, key) in queryTypeOptions"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
              <a-input
                v-model:value="addQuery.search"
                style="width: 410px;"
                placeholder="支持多个筛选，以英文逗号分割"
                @change="
                  e =>
                    searchInputLengthCut({
                      val: e.target.value,
                      key: 'addQuery'
                    })
                "
                @pressEnter="changeVisible"
              >
                <template #prefix>
                  <SearchOutlined
                    class="cp"
                    style="color: #ccc;"
                    @click="changeVisible"
                  />
                </template>
              </a-input>
            </a-input-group>
          </div>
          <div>
            <a-table
              :dataSource="addAsyncDataSource"
              :customRow="customRowAddsearch"
              :columns="addAsyncColumns"
              :pagination="false"
              :scroll="{ y: 300 }"
            >
              <template #titleSlot="{index, record}">
                <div class="df">
                  <a-checkbox
                    :checked="false"
                    class="mr10"
                    @change="() => backCol(index, record)"
                  ></a-checkbox>
                  <div style="width: 100px;">{{ record.title }}</div>
                </div>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="tar pr oh" v-if="asyncVisible === 2">
        <div class="fl">
          <span class="lh30 mr10">同步后启用</span
          ><a-switch v-model:checked="status" />
        </div>
        <a-button type="default" @click="asyncVisibleChange(0)">取消</a-button>
        <a-button type="primary" v-if="!mixDetailVisible" @click="asyncNow"
          >同步</a-button
        >
      </div>
    </template>
  </a-modal>
</template>
<script>
import { SearchOutlined } from '@ant-design/icons-vue'
import { inject, toRefs, reactive, onMounted } from 'vue'
export default {
  components: {
    SearchOutlined
  },
  setup() {
    const state = reactive({
      customRowAddsearch: row => {
        return {
          class: row.search === false ? 'colP-tr-hide' : ''
        }
      },
      checked: false,
      queryTypeOptions: [
        // { value: null, label: '全部' },
        { value: 0, label: 'Shopfiy ID' }
        // ,
        // { value: 1, label: 'Title' },
        // { value: 2, label: 'SEO' }
      ],
      logColumns: [
        {
          title: '同步人',
          dataIndex: 'creatorName',
          key: 'creatorName',
          align: 'center'
        },
        {
          title: '同步时间',
          dataIndex: 'syncTime',
          key: 'syncTime',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
          align: 'center',
          width: 240
        }
      ],
      asyncColumns: [
        {
          title: 'Title',
          dataIndex: 'titleSlot',
          key: 'titleSlot',
          align: 'center',
          slots: { customRender: 'titleSlot' }
        },
        {
          title: 'SEO',
          dataIndex: 'seoUrl',
          key: 'seoUrl',
          align: 'center'
        },
        {
          title: 'ShopfiyID',
          dataIndex: 'shopifyCollectionId',
          key: 'shopifyCollectionId',
          align: 'center'
        }
      ],
      addAsyncColumns: [
        {
          title: 'Title',
          dataIndex: 'titleSlot',
          key: 'titleSlot',
          align: 'center',
          slots: { customRender: 'titleSlot' }
        },
        {
          title: 'SEO',
          dataIndex: 'seoUrl',
          key: 'seoUrl',
          align: 'center'
        },
        {
          title: 'ShopfiyID',
          dataIndex: 'shopifyCollectionId',
          key: 'shopifyCollectionId',
          align: 'center'
        }
      ]
    })

    onMounted(() => {
      const { initLog, asyncVisible } = inject('initState')
      if (asyncVisible === 1) {
        initLog()
      }
    })

    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.red {
  color: red;
}
</style>
<style>
.colP-tr-hide,
.colP-tr-hide td,
tr[showdom='false'] {
  display: none;
}
</style>
